<template>
  <BaseStreemTooltip v-if="showTooltip">
    {{ getLocaleText(`universal_player_control_widget.${name}`) }}
  </BaseStreemTooltip>
  <span
    v-else
    class="tw:ml-2 tw:text-base tw:font-normal tw:leading-7 tw:group"
  >
    {{ getLocaleText(`universal_player_control_widget.${name}`) }}
  </span>
</template>

<script lang="ts" setup>
import { getLocaleText } from "shared/boot/i18n";
import BaseStreemTooltip from "shared/components/base/BaseStreemTooltip";

import type { ButtonLabelProps } from "./types";

defineProps<ButtonLabelProps>();
</script>
